<div class="frame">
  <app-audience></app-audience>
  <div class="footer-area"></div>
</div>
